import React, { ReactElement } from "react";

export default function LedControl(): ReactElement {
    return <div>Hi</div>;
}
